<template>
  <component :is="latestnews" />
</template>

<script>
export default {
  name: 'latestnews',
  components: {
    commonLatestNews: () => import(`@/components/different/common/latestNews/latestNews`),
    venicemanLatestNews: () => import(`@/components/different/veniceman/latestNews/latestNews`),
    betlLatestNews: () => import(`@/components/different/betl/latestNews/latestNews`),
    b027siteLatestNews: () => import(`@/components/different/b027site/latestNews/latestNews`),
    b027sportLatestNews: () => import(`@/components/different/b027sport/latestNews/latestNews`),
    yongligaoLatestNews: () => import(`@/components/different/yongligao/latestNews/latestNews`)
  },
  data () {
    return {
      differentSite: null
    }
  },
  created () {
  },
  computed: {
    latestnews() {
      switch (process.env.siteName) {
        case 'veniceman':
          this.differentSite = true
          break
        case 'betl':
          this.differentSite = true
          break
        case 'b027site':
          this.differentSite = true
          break
        case 'b027sport':
          this.differentSite = true
          break
        case 'yongligao':
          this.differentSite = true
          break
        default:
          this.differentSite = false
          break
      }
      return (this.differentSite ? `${process.env.siteName}LatestNews` : 'commonLatestNews')
    }
  },
  methods: {
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
</style>




// WEBPACK FOOTER //
// latestNews.vue?5d94e69f